import { proposalsService } from '@/services/proposals';
import type { AttachQuotePayload } from '@/services/proposals/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateProposal(
  proposalId: string,
  productCode?: string | null
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Partial<AttachQuotePayload>) => {
      const response = await proposalsService.updateProposal(
        proposalId,
        payload,
        productCode
      );
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao atualizar proposta');
      }
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['proposal', proposalId],
      });
    },
  });
}
